// extracted by mini-css-extract-plugin
module.exports = {"composer":"styles_composer__V90W1"};